import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AppContextProvider } from "components/Context/AppContext";
import { AuthProvider } from "components/Context/AuthContext";
import WebsitehomePage from "pages/TailRiskGlobal";
import NotFound from "pages/NotFound";
import PortfoliosPage from "pages/Portfolios";
import Login from "pages/Login";
import CreateAccount from "pages/CreateAccount";
import Summary from "pages/Summary";
import HoldingsPage from "pages/Holdings";
import RiskPage from "pages/Risk";
import StressScenarios from "pages/StressScenarios";
import ResetPassword from "pages/ResetPassword";
import LoginRequired from "components/Context/LoginRequired";
import ForgetPassword from "pages/ForgetPassword";
import UserApproval from "pages/UserApproval";
import ResetPasswordAfterLogin from "pages/ResetPasswordAfterLogin";
import UpdateEntitlement from "pages/UpdateEntitlement";
import PageUploadSecurity from "pages/UploadSecurity";
import WhatIfAnalysis from "pages/WhatIfAnalysis";
import SettingsPage from "pages/Settings";
import HistoricalPage from "pages/Historical";
import MasterDashboard from "pages/MasterDashboard";
import AlternativesPage from "pages/Alternatives";
import SecurityLevelPage from "pages/SecurityLevel";



function App() {


  return (
    <AuthProvider>
      <AppContextProvider>
        <Router>    
          <div className="content">
              <Routes>
                <Route exact path="/"         element={<WebsitehomePage />} />
                <Route path="/home"           element={<WebsitehomePage />} />
                <Route path="/login"          element={<Login           />} />
                <Route path="/createAccount"  element={<CreateAccount   />} />

                <Route path="/dashboard"            element={<LoginRequired> <MasterDashboard /> </LoginRequired>} />
                <Route path="/summary"              element={<LoginRequired> <Summary />       </LoginRequired>} />
                <Route path="/holdings" element={<LoginRequired> <HoldingsPage /> </LoginRequired>} />
                <Route path="/risk"      element={<LoginRequired> <RiskPage />        </LoginRequired>} />
                <Route path="/stress"   element={<LoginRequired> <StressScenarios /> </LoginRequired>} />
                <Route path="/portfolios"       element={<LoginRequired> <PortfoliosPage /> </LoginRequired>} />

                <Route path="/resetPassword/:token"     element={<ResetPassword             />} />
                <Route path="/resetPasswordafterlogin"  element={<ResetPasswordAfterLogin   />} />
                <Route path="/forgetPassword"        element={<ForgetPassword    /> } />

                <Route path="/userApproval"          element={<LoginRequired> <UserApproval      /> </LoginRequired> } />
                <Route path="/updateEntitlement"     element={<LoginRequired> <UpdateEntitlement /> </LoginRequired> } />
                <Route path="/pageUploadSecurity"    element={<LoginRequired> <PageUploadSecurity /> </LoginRequired> } />
                <Route path="/whatif"               element={<LoginRequired> <WhatIfAnalysis /> </LoginRequired>} />
                <Route path="/settings"            element={<LoginRequired> <SettingsPage />   </LoginRequired>} />
                <Route path="/historical"          element={<LoginRequired> <HistoricalPage />   </LoginRequired>} />
                <Route path="/alternatives"       element={<LoginRequired> <AlternativesPage /> </LoginRequired>} />
                <Route path="/security-level"    element={<LoginRequired> <SecurityLevelPage /> </LoginRequired>} />


                <Route path="*"               element={<NotFound        />} />


              </Routes>
            </div>

        </Router>
      </AppContextProvider>
    </AuthProvider>
  );
}

export default App;
